<template>
  <v-dialog v-model="dialogVisible" width="700" persistent no-click-animation overlay-color="grey-500">
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar color="transparent" flat height="46">
          <v-toolbar-title class="px-5 subtitle-2 grey-500--text font-weight-semibold">Eliminar de la categoría</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-3">
              <v-btn @click="close" icon small retain-focus-on-click><v-icon color="grey-500" size="20">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
      </v-card-title>
      <v-divider />
      <v-card-text class="py-5 px-5">
        <v-alert class="inf-alert-yellow yellow-700--text rounded-md mb-5" dense outlined>
          <div class="d-flex py-2 align-center">
            <v-icon color="yellow-700" size="28">mdi-alert-outline</v-icon>
            <div class="ml-4">
              <span class="body-1 font-weight-bold yellow-700--text">Atención</span>
              <span class="d-block body-2 yellow-700--text">Al eliminar el proveedor {{ supplier.name || 'Sin nombre' }} de la categoría {{ categoryName }}, el proveedor quedará sin categoría y se le aplicarán las reglas de recepción correspondientes</span>
            </div>
          </div>
        </v-alert>
        <span class="d-block grey-500--text mb-2">Escribe <span class="font-weight-bold">"confirmar"</span> para continuar.</span>
        <v-text-field v-model="confirm" outlined single-line maxlength="9" hide-details @keyup.enter="confirm.toLowerCase() === 'confirmar' && handleConfirm()" />
      </v-card-text>
      <v-divider />
      <v-card-actions class="py-2 px-5">
        <v-spacer/>
        <v-btn @click="close" outlined>Cancelar</v-btn>
        <v-btn color="grey-900" @click="handleConfirm" :loading="loading" :disabled="confirm.toLowerCase() !== 'confirmar'">Confirmar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SupplierDeleteCategoryModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    supplier: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      confirm: ''
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    categoryName () {
      return this.supplier.category_details?.name || this.supplier.group_details?.name || 'Sin categoría'
    }
  },
  watch: {
    value (val) {
      if (!val) {
        this.clear()
      }
    }
  },
  methods: {
    handleConfirm () {
      if (this.confirm.toLowerCase() !== 'confirmar') return
      this.$emit('confirm', {
        supplier: this.supplier,
        categoryId: this.supplier.segment_id
      })
    },
    clear () {
      this.confirm = ''
    },
    close () {
      this.clear()
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.inf-alert-yellow.v-alert--outlined {
  border-color: var(--light-yellow-700) !important;
  background-color: var(--light-yellow-100) !important;
}
</style>
